import { FC } from 'react';
import { CoMoWizardConfig } from '@app/form_components/CoMoWizardConfig';

export const SettingsWizardConfigPage: FC = () => {
  return (
    <div className="row">
      <div className="col-md-12">
        <CoMoWizardConfig />
      </div>
    </div>
  );
};

